"use client";

import { domId } from "@/lib/dom-id";
import { useTranslations } from "next-intl";
import { Button } from "@/components/ui";

interface AccessDeniedModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
}

export default function AccessDeniedModal({
  isOpen,
  onClose,
  title,
  message,
}: AccessDeniedModalProps) {
  const t = useTranslations("AccessDeniedModal");
  if (!isOpen) return null;

  const resolvedTitle = title || t("title");
  const resolvedMessage = message || t("message");

  return (
    <div
      data-testid={domId("mdl", "access-denied-modal")}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
    >
      <div className="w-full max-w-md rounded-xl bg-white shadow-2xl p-6">
        {/* Header with Icon and Title */}
        <div className="flex items-start gap-3 mb-4">
          <svg
            className="h-5 w-5 flex-shrink-0 text-red-600 mt-0.5"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
          <div className="flex-1">
            <h2 className="text-base font-semibold text-gray-900">
              {resolvedTitle}
            </h2>
          </div>
        </div>

        {/* Message */}
        <p className="text-sm text-gray-600 mb-4 leading-relaxed">
          {resolvedMessage}
        </p>

        {/* Button */}
        <div className="flex justify-end">
          <Button
            data-testid={domId("btn", "access-denied-close")}
            type="button"
            onClick={onClose}
             variant="unstyled" className="rounded-md px-4 py-2 text-sm font-medium text-white transition"
            style={{ background: 'linear-gradient(to right, #713D98, #3E3D98)' }}
          >
            {t("actions.gotIt")}
          </Button>
        </div>
      </div>
    </div>
  );
}
